  // console.log("custom.js loaded");

  // slider testimonials

  // $(document).ready(function () {
  //   const $slider = $(".testimonial-slider");
  //   const $slides = $(".testimonial-card");
  //   const $prevBtn = $(".slider-button--prev");
  //   const $nextBtn = $(".slider-button--next");
  //   const $dotsContainer = $(".testimonial-dots");

  //   let cardsPerPage;
  //   let totalPages;
  //   let currentPage = 0;
  //   let isMobile = false;

  //   function setCardsPerPage() {
  //     if ($(window).width() <= 768) {
  //       cardsPerPage = 1;
  //       isMobile = true;
  //       $prevBtn.hide();
  //       $nextBtn.hide();
  //     } else {
  //       cardsPerPage = 3;
  //       isMobile = false;
  //       $prevBtn.show();
  //       $nextBtn.show();
  //     }
  //     totalPages = Math.ceil($slides.length / cardsPerPage);
  //   }

  //   function createDots() {
  //     $dotsContainer.empty();
  //     for (let i = 0; i < totalPages; i++) {
  //       const $dot = $("<button></button>");
  //       if (i === currentPage) $dot.addClass("active");
  //       $dot.on("click", function () {
  //         currentPage = i;
  //         if (isMobile) {
  //           const cardWidth = $slides.outerWidth(true);
  //           $slider.animate({ scrollLeft: cardWidth * currentPage }, 300);
  //         } else {
  //           updateSlider();
  //         }
  //       });
  //       $dotsContainer.append($dot);
  //     }
  //   }

  //   function updateButtons() {
  //     // kasih efek disable kaya swiper
  //     if (currentPage <= 0) {
  //       $prevBtn.addClass("is-disabled");
  //     } else {
  //       $prevBtn.removeClass("is-disabled");
  //     }

  //     if (currentPage >= totalPages - 1) {
  //       $nextBtn.addClass("is-disabled");
  //     } else {
  //       $nextBtn.removeClass("is-disabled");
  //     }
  //   }

  //   function updateSlider() {
  //     const index = currentPage * cardsPerPage;
  //     const targetCard = $slides.eq(index);

  //     if (targetCard.length) {
  //       const offset = targetCard.position().left;
  //       $slider.css("transform", `translateX(-${offset}px)`);
  //     }

  //     const $dots = $dotsContainer.find("button");
  //     $dots.removeClass("active");
  //     $dots.eq(currentPage).addClass("active");

  //     updateButtons();
  //   }

  //   $nextBtn.on("click", function () {
  //     if (currentPage < totalPages - 1) {
  //       currentPage++;
  //       updateSlider();
  //     }
  //   });

  //   $prevBtn.on("click", function () {
  //     if (currentPage > 0) {
  //       currentPage--;
  //       updateSlider();
  //     }
  //   });

  //   // Mobile: update dot saat scroll
  //   $slider.on("scroll", function () {
  //     if (isMobile) {
  //       const scrollLeft = $slider.scrollLeft();
  //       const cardWidth = $slides.outerWidth(true); // include margin/gap
  //       const newIndex = Math.round(scrollLeft / cardWidth);
  //       currentPage = Math.min(newIndex, totalPages - 1);

  //       const $dots = $dotsContainer.find("button");
  //       $dots.removeClass("active");
  //       $dots.eq(currentPage).addClass("active");

  //       updateButtons();
  //     }
  //   });

  //   function initSlider() {
  //     setCardsPerPage();
  //     createDots();
  //     if (!isMobile) updateSlider();
  //     updateButtons();
  //   }

  //   initSlider();

  //   $(window).on("resize", function () {
  //     const oldCardsPerPage = cardsPerPage;
  //     setCardsPerPage();
  //     if (cardsPerPage !== oldCardsPerPage) {
  //       currentPage = 0;
  //       createDots();
  //       if (!isMobile) updateSlider();
  //       updateButtons();
  //     }
  //   });
  // });

  // document.querySelectorAll('.js-toggle-filter').forEach(btn => {
  //   btn.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     e.stopPropagation(); // cegah bubbling ke event bawaan
  //     const parent = this.closest('.mobile-facets__details');
  //     parent.classList.toggle('open');
  //   });
  // });

  // end

  // Sidebar Menu
  $(document).ready(function() {

    // Toggle submenu utama
    $('.submenu-toggle').on('click', function(e) {
      e.preventDefault();
      let targetId = $(this).data('target') || $(this).attr('id').replace('HeaderDrawer-', 'link-');
      let $submenu = $('#' + targetId);

      if ($submenu.length) {
        $submenu.slideToggle(200);
        $(this).toggleClass('menu-drawer__menu-item--active');
      } else {
        // console.warn('Submenu not found:', targetId);
      }
    });

    // Toggle submenu anak
    $('.childlink-toggle').on('click', function(e) {
      e.preventDefault();
      let targetId = $(this).data('target');
      let $submenu = $('#' + targetId);

      if ($submenu.length) {
        $submenu.slideToggle(200);
        $(this).toggleClass('menu-drawer__menu-item--active');
      }
    });

    // Tombol kembali submenu
    $('.js-submenu-back').on('click', function() {
      let $submenu = $(this).closest('.menu-drawer__submenu');
      $submenu.slideUp(200);

      // hapus active class dari tombol toggle terkait
      $submenu.prev('.submenu-toggle, .childlink-toggle').removeClass('menu-drawer__menu-item--active');
    });

  });
  // end


  // blog and tips 
  // document.addEventListener("DOMContentLoaded", () => {
  //   const tabs = document.querySelectorAll('.menu-tab');
  //   const grids = document.querySelectorAll('.menu-grid');

  //   if (tabs.length === 0 || grids.length === 0) return;

  //   // ✅ Fungsi untuk aktivasi tab tertentu
  //   function activateTab(index) {
  //     tabs.forEach((btn, i) => {
  //       btn.classList.toggle('active', i === index);   // toggle class active
  //     });

  //     grids.forEach((grid, i) => {
  //       grid.style.display = i === index ? 'grid' : 'none'; // tampilkan grid sesuai index
  //     });
  //   }

  //   // ✅ Set default tab pertama
  //   activateTab(0);

  //   // ✅ Event click untuk tab
  //   tabs.forEach((button, index) => {
  //     button.addEventListener('click', () => {
  //       activateTab(index);
  //     });
  //   });

  //   // 🔄 BONUS: sinkronisasi dengan select (mobile)
  //   const select = document.querySelector("#menu-tabs-select");
  //   if (select) {
  //     select.addEventListener("change", () => {
  //       activateTab(parseInt(select.value, 10));
  //     });
  //   }
  // });
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll('.menu-tab');
  const grids = document.querySelectorAll('.menu-grid');
  const select = document.querySelector("#menu-tabs-select");
  const trigger = document.querySelector(".menu-tabs-trigger");
  const tabsContainer = document.querySelector(".menu-tabs");
  const label = document.querySelector(".menu-tabs-label");

  if (!tabs.length || !grids.length) return;

  // ✅ Fungsi untuk aktivasi tab tertentu (desktop + mobile)
  function showTab(tabValue) {
    tabs.forEach(t => t.classList.remove('active'));

    // Tambahkan active class di tab desktop
    if(tabValue === 'all') {
      const allTab = document.querySelector('.menu-tab[data-tab="all"]');
      if(allTab) allTab.classList.add('active');
    } else {
      const tab = document.querySelector(`.menu-tab[data-tab="${tabValue}"]`);
      if(tab) tab.classList.add('active');
    }

    // Update grid
    grids.forEach((grid, index) => {
      if(tabValue === 'all') {
        grid.style.display = 'grid';
      } else {
        grid.style.display = (grid.dataset.tabContent === tabValue) ? 'grid' : 'none';
      }

      // margin-top 40px untuk block ke-2 yang tampil
      grid.style.marginTop = (grid.style.display !== 'none' && index === 1) ? '40px' : '0';
    });

    // update mobile select
    if(select) select.value = tabValue;

    // update mobile trigger label
    if(label && tabValue !== 'all') {
      const activeTab = document.querySelector(`.menu-tab[data-tab="${tabValue}"]`);
      if(activeTab) label.textContent = activeTab.textContent;
    } else if(label && tabValue === 'all') {
      label.textContent = 'All Events';
    }
  }

  // ✅ Trigger All Events saat load
  showTab('all');

  // ✅ Klik tab desktop
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabValue = tab.dataset.tab;
      showTab(tabValue);

      // tutup list mobile jika ada trigger
      if(tabsContainer) tabsContainer.classList.remove('show');
      if(label) label.textContent = tab.textContent;
    });
  });

  // 🔄 Change select mobile
  if(select) {
    select.addEventListener("change", () => {
      showTab(select.value);
    });
  }

  // toggle buka/tutup list di mobile
  if(trigger) {
    trigger.addEventListener("click", () => {
      if(tabsContainer) tabsContainer.classList.toggle("show");
    });
  }
});

  // end

  const trigger = document.querySelector(".menu-tabs-trigger");
  const tabsContainer = document.querySelector(".menu-tabs");
  const tabs = document.querySelectorAll(".menu-tab");
  const label = document.querySelector(".menu-tabs-label");

  // toggle buka/tutup list di mobile
  if (trigger) {
    trigger.addEventListener("click", () => {
      tabsContainer.classList.toggle("show");
    });
  }

  // klik salah satu tab
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      // update label di trigger (mobile)
      label.textContent = tab.textContent;

      // tutup list
      tabsContainer.classList.remove("show");
    });
  });


  // collection page 
  const slider = document.querySelector('slider-component');
  if (slider) {
    const slides = slider.querySelectorAll('.slider__slide');
    const slidesPerPage = 4; // desktop
    const totalPages = Math.ceil(slides.length / slidesPerPage);
    // generate dots manually
    const dotsContainer = document.createElement('div');
    dotsContainer.classList.add('dots');
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.addEventListener('click', () => {
        const pageWidth = slidesPerPage * slides[0].offsetWidth; 
        slider.querySelector('[id^="Slider-"]').scrollTo({ left: i * pageWidth, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    }
    slider.appendChild(dotsContainer);
  }


  // testimonial dan collection prudct home
  if($('.collection-slider').length){
    document.addEventListener("DOMContentLoaded", function() {
      // console.log('before loop')
      let renderSlider = setInterval(function() {
        let slider = document.querySelector('.collection-slider');
        if (slider) {
          if (slider.classList.contains('swiper-initialized')) {
            // console.log('finish loop')
            clearInterval(renderSlider);
          }
          else {
            // console.log('loop renderSLider')
            new Swiper(".collection-slider", {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 16,
              navigation: {
                nextEl: ".collection-slider .swiper-button-next",
                prevEl: ".collection-slider .swiper-button-prev",
              },
              pagination: {
                el: ".collection-slider .swiper-pagination",
                clickable: true,
              },
              breakpoints: {
                0: { slidesPerView: 1.2 },
                768: { slidesPerView: 2.2 },
                1024: { slidesPerView: 4 },
              },
            });
          }
        }
        else {
          // console.log('loop')
        }
      }, 0)
    });
  }

  // product details
  document.addEventListener("DOMContentLoaded", initAccordion);

    function initAccordion() {
    const toggles = document.querySelectorAll(".accordion-toggle");
    if (!toggles.length) {
      // console.log("No accordion toggles found yet");
      return;
    }
    // console.log("Accordion toggles found:", toggles.length);

    toggles.forEach(toggle => {
      // cegah double binding
      if (!toggle.dataset.accordionBound) {
        toggle.dataset.accordionBound = true;

        toggle.addEventListener("click", () => {
          // console.log("kepencet");
          const content = toggle.nextElementSibling;
          if (!content) return;

          // tutup accordion lain
          document.querySelectorAll(".accordion-content").forEach(c => {
            if (c !== content) {
              c.style.maxHeight = null;
              c.previousElementSibling.classList.remove("active");
            }
          });

          // buka/tutup yang diklik
          toggle.classList.toggle("active");
          content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + "px";
        });
      }
    });
  }

  // end
  // product page
  document.addEventListener("DOMContentLoaded", function () {
    const thumbButtons = document.querySelectorAll(".thumbnail-list__item button");

    thumbButtons.forEach((btn, i) => {
      btn.addEventListener("mouseenter", function () {
        // console.log("Hover thumbnail index:", i, " → trigger click()");
        btn.click(); // jalanin mekanisme bawaan Dawn
      });
    });
  });


  // testimonial
  document.addEventListener("DOMContentLoaded", function () {
    const testimonialSlider = document.querySelector(".testimonial-swiper");
    if (testimonialSlider) {
      new Swiper(".testimonial-swiper", {
        slidesPerView: 3,
        spaceBetween: 25,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto', // otomatis, pakai CSS width di bawah
            spaceBetween: 24,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 25,
          }
        }

      });
    }
  });
  // end

  // dropdown filter
  document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.querySelector(".custom-dropdown");
    if (!dropdown) return; // kalau gak ada dropdown di halaman ini, stop biar gak error

    const toggleBtn = dropdown.querySelector(".dropdown-toggle__filter");
    const menu = dropdown.querySelector(".dropdown-menu");
    const items = dropdown.querySelectorAll(".dropdown-item");

    // buka/tutup dropdown
    toggleBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      menu.classList.toggle("show");
    });

    // pilih item
    items.forEach(item => {
      item.addEventListener("click", function () {
        const value = this.dataset.value;
        const text = this.textContent;

        // update tampilan tombol
        toggleBtn.innerHTML = text;
        menu.classList.remove("show");

        // redirect dengan sort_by
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("sort_by", value);
        window.location.href = currentUrl.toString();
      });
    });
  });

  // end

  // filter mobile
  document.addEventListener("DOMContentLoaded", function () {
    const sortSelect = document.getElementById("SortBy-mobile");
    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", this.value);
        window.location = url.toString();
      });
    }
  });
  // end

  // filter category
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-dropdown").forEach(dropdown => {
      // console.log("Ketemu dropdown:", dropdown);

      let toggle = dropdown.querySelector(".dropdown-toggle");
      let menu = dropdown.querySelector(".dropdown-menu");

      // 🔥 fallback: kalau <ul class="dropdown-menu"> gak ada, bikin kosong
      if (!menu) {
        menu = document.createElement("ul");
        menu.classList.add("dropdown-menu");
        dropdown.appendChild(menu);
        // console.warn("Dropdown menu auto-created:", dropdown);
      }

      if (!toggle) {
        // console.warn("Dropdown tanpa toggle:", dropdown);
        return;
      }

      // klik toggle
      toggle.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // ⛔ lebih kuat dari stopPropagation

    // console.log("Klik toggle:", toggle);

    const isOpen = menu.classList.contains("open");

    // tutup semua dulu
    document.querySelectorAll(".custom-dropdown .dropdown-menu")
      .forEach(m => m.classList.remove("open"));

    // toggle menu ini
    if (!isOpen) menu.classList.add("open");
  }, true); // ⛔ tambahin true = capture phase


      // klik item
      menu.querySelectorAll(".dropdown-item").forEach(item => {
        item.addEventListener("click", function (e) {
          e.stopPropagation(); // ⛔ biar klik item gak nutup drawer duluan

          // console.log("Klik item:", this.textContent.trim());
          const url = this.dataset.url;

          if (url) {
            // 🔄 kalau mau reload page normal:
            // window.location.href = url;

            // 🔥 kalau mau AJAX (replace produk aja):
            fetch(url)
              .then(res => res.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const newGrid = doc.querySelector("#ProductGridContainer, .product-grid");
                const container = document.querySelector("#ProductGridContainer, .product-grid");

                if (newGrid && container) {
                  container.innerHTML = newGrid.innerHTML;
                  document.body.classList.remove(
                    'overflow-hidden-mobile',
                    'overflow-hidden-tablet',
                    'overflow-hidden-desktop'
                  );
                }
              
                // tutup menu setelah klik
                menu.classList.remove("open");
              })
              .catch(err => console.error("Filter AJAX error:", err));
          }
        });
      });
    });

    // klik luar → tutup semua
    document.addEventListener("click", function () {
      document.querySelectorAll(".custom-dropdown .dropdown-menu")
        .forEach(menu => menu.classList.remove("open"));
    });
  });

  // end

  // dot product mobile
  document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth >= 768) return; // hanya mobile

    const slider = document.querySelector(".product__media-list");
    if (!slider) return;

    const slides = slider.querySelectorAll(".product__media-item");
    if (slides.length <= 1) return;

    const dotsWrapper = document.createElement("div");
    dotsWrapper.className = "custom-product-dots";
    const dots = [];

    // Buat dot untuk setiap slide
    slides.forEach((slide, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "custom-dot";
      dot.setAttribute("aria-label", `Slide ${index + 1}`);
      dot.innerHTML = "<span class='dot-shape'></span>";

      // Klik → scroll ke slide (tanpa set active manual)
      dot.addEventListener("click", (e) => {
        e.preventDefault();
        slide.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest"
        });
      });

      dots.push(dot);
      dotsWrapper.appendChild(dot);
    });

    slider.parentElement.appendChild(dotsWrapper);

    // Observer untuk update dot aktif
    const observer = new IntersectionObserver((entries) => {
      // Ambil entry dengan ratio terbesar (slide paling keliatan)
      let mostVisible = entries.reduce((prev, curr) => {
        return (curr.intersectionRatio > prev.intersectionRatio) ? curr : prev;
      });

      if (mostVisible.isIntersecting) {
        const idx = Array.from(slides).indexOf(mostVisible.target);

        if (idx !== -1) {
          dots.forEach(d => d.classList.remove("active")); // reset semua
          dots[idx].classList.add("active"); // aktifin hanya satu
        }
      }
    }, {
      root: slider,
      threshold: [0.3, 0.6, 0.9] // lebih detail, biar dapet ratio
    });

    slides.forEach(slide => observer.observe(slide));

    // Set awal
    dots[0].classList.add("active");
  });

  // custom cekout

  document.addEventListener("DOMContentLoaded", function() {
    // 1. Cek apakah di halaman ada elemen .main-cart__template
    if (document.querySelector(".main-cart__template")) {

      // 2. Pindahin #main-cart-footer ke dalam .cart__items-pricing
      const cartPricing = document.querySelector(".cart__items-pricing");
      const cartFooter = document.querySelector("#main-cart-footer");
      if (cartPricing && cartFooter) {
        cartPricing.appendChild(cartFooter);
      }

      // 3. Select all checkbox
      const selectAll = document.querySelector("#select-all");
      const itemCheckboxes = document.querySelectorAll(".select-item");

      if (selectAll && itemCheckboxes.length > 0) {
        // Kalau select-all berubah → semua item ikut
        selectAll.addEventListener("change", function() {
          itemCheckboxes.forEach(cb => {
            cb.checked = selectAll.checked;
          });
        });

        // Kalau item berubah → update status select-all
        itemCheckboxes.forEach(cb => {
          cb.addEventListener("change", function() {
            const allChecked = Array.from(itemCheckboxes).every(i => i.checked);
            selectAll.checked = allChecked;
          });
        });
      }

      // 4. Delete all button
      const deleteAllBtn = document.querySelector(".delet-all__button");
      if (deleteAllBtn) {
        deleteAllBtn.addEventListener("click", function() {
          fetch("/cart/clear.js", { method: "POST" })
            .then(res => {
              if (res.ok) {
                location.reload();
              } else {
                console.error("Gagal clear cart");
              }
            })
            .catch(err => console.error("Error:", err));
        });
      }

    }
  });

  // trigger button X search
  document.addEventListener('DOMContentLoaded', () => {
    const resetButton = document.querySelector('.reset__button');
    const searchResults = document.querySelector('[data-search-results]');
    const searchInput = document.querySelector('input[type="search"]');
    const productGrid = document.querySelector('#product-grid');
    const filterWrapper = document.querySelector('#main-search-filters');

    if (!resetButton || !searchResults || !searchInput) return;

    resetButton.addEventListener('click', (e) => {
      // Tunggu sedikit sampai input bener-bener ke-reset
      setTimeout(() => {
        if (searchInput.value.trim() === '') {
          // Kosongkan hasil search
          searchResults.innerHTML = '';

          // Hapus isi produk (kalau ada)
          if (productGrid) productGrid.innerHTML = '';

          // Sembunyikan filter/facets (kalau ada)
          if (filterWrapper) filterWrapper.style.display = 'none';

          // (Opsional) tampilkan placeholder message
          const msg = document.createElement('p');
          msg.textContent = 'Start typing to search products...';
          msg.classList.add('no-results-message');
          searchResults.appendChild(msg);
        }
      }, 50);
    });
  });

  // end

  // infinity loop mobile collection product
  document.addEventListener("DOMContentLoaded", async function () {
    const productGrid = document.querySelector("#product-grid");
    const paginationWrapper = document.querySelector(".pagination-wrapper");

    if (!productGrid) {
      // console.warn("❌ #product-grid tidak ditemukan.");
      return;
    }

    if (window.innerWidth > 768) {
      // console.log("🛑 Desktop mode - infinite scroll off");
      return;
    }

    // console.log("✅ Init auto-load pagination (mobile)");

    if (paginationWrapper) paginationWrapper.style.display = "none";

    // ambil pagination link pertama
    let nextLink = document.querySelector(
      '.pagination a[aria-label*="Next"], .pagination a[rel="next"], .pagination__item--next a, .pagination a[href*="?page="]'
    );

    let lastUrl = null;
    const loadedPages = new Set();

    // ambil current page number dari pagination
    const currentPageEl = document.querySelector('.pagination__item--current');
    let currentPage = currentPageEl ? parseInt(currentPageEl.textContent.trim(), 10) : 1;

    while (nextLink) {
      const nextUrl = nextLink.href;

      // cegah ngulang page yang sama
      if (nextUrl === lastUrl || loadedPages.has(nextUrl)) {
        // console.log("🛑 Detected same URL again, stop loop:", nextUrl);
        break;
      }

      // ambil nomor page dari URL
      const match = nextUrl.match(/[?&]page=(\d+)/);
      const nextPageNum = match ? parseInt(match[1], 10) : null;

      // pastikan page-nya lebih besar dari current
      if (nextPageNum && nextPageNum <= currentPage) {
        // console.log(`⚠️ Skip ${nextPageNum} karena <= current (${currentPage})`);
        break;
      }

      // console.log("🔄 Fetching:", nextUrl);
      loadedPages.add(nextUrl);
      lastUrl = nextUrl;

      try {
        const res = await fetch(nextUrl, { credentials: "same-origin" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll("#product-grid .grid__item, #product-grid > li");
        // console.log(`🧩 Found ${newProducts.length} new products from page ${nextPageNum}`);

        if (newProducts.length === 0) {
          // console.log("⚠️ Tidak ada produk baru, stop.");
          break;
        }

        newProducts.forEach((item) => productGrid.appendChild(item));

        // update currentPage
        if (nextPageNum) currentPage = nextPageNum;

        // cari link "Next" di halaman baru
        const newNext = doc.querySelector(
          '.pagination a[aria-label*="Next"], .pagination a[rel="next"], .pagination__item--next a'
        );

        if (newNext) {
          // console.log("➡️ Next page found:", newNext.href);
          nextLink = newNext;
        } else {
          // console.log("🏁 Semua halaman sudah di-load, stop.");
          break;
        }
      } catch (err) {
        console.error("🔥 Fetch error:", err);
        break;
      }
    }

    // console.log("✅ Infinite load selesai tanpa fetch ulang page 1.");
  });

  // end
  
  // coba coba blog
  